var map = {
	"./alema.webp": 8896,
	"./alema_amendoim.webp": 1241,
	"./alema_branca.webp": 3368,
	"./alema_nozes.webp": 1099,
	"./alema_ovomaltine.webp": 5276,
	"./alema_sem_acucar.webp": 8444,
	"./ameixa.webp": 3271,
	"./amendoim_sem_acucar.webp": 4371,
	"./banana.webp": 1811,
	"./banoffee.webp": 3198,
	"./bombonzao.webp": 7941,
	"./brigadeiro.webp": 9483,
	"./brownie.webp": 3118,
	"./brownie_morango.webp": 8024,
	"./cafe.webp": 1228,
	"./caramelo.webp": 9899,
	"./cheesecake.webp": 755,
	"./cheesecake_goiaba.webp": 2783,
	"./cheesecake_nutella.webp": 5403,
	"./cheesecake_sem_acucar.webp": 8767,
	"./chocolatra.webp": 6189,
	"./damasco.webp": 9885,
	"./docedelicia.webp": 9400,
	"./domino.webp": 1949,
	"./donaana.webp": 3913,
	"./feitico.webp": 6615,
	"./gabriela.webp": 5062,
	"./limao.webp": 7285,
	"./maca.webp": 902,
	"./maracuja.webp": 4624,
	"./menta.webp": 2504,
	"./mesclada.webp": 1994,
	"./morango.webp": 6578,
	"./mousse.webp": 3690,
	"./mousse_brigadeiro.webp": 4034,
	"./mousse_sem_acucar.webp": 3263,
	"./nozes.webp": 1853,
	"./paodemel.webp": 9877,
	"./pontanegra.webp": 6215,
	"./profiterolis.webp": 8856,
	"./redvelvet.webp": 7497,
	"./romeu.webp": 4101,
	"./seducao.webp": 2232,
	"./spumone.webp": 3562,
	"./tentacao.webp": 6566,
	"./tropical.webp": 9982
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8092;